<template>

    <form autocomplete="off" class="trax-form mb-4">

        <trax-ui-select :placeholder="lang.polaris.dashboard.location" 
            v-model="form.entity_id" :error="errors.entity_id" :options="locations_select" 
            grouped="1" col="md-3">
        </trax-ui-select>

        <trax-ui-datetime :placeholder="lang.polaris.dashboard.date" col="md-3"
            v-model="form.date" :error="errors.date" type="date" required="1">
        </trax-ui-datetime>

        <trax-ui-input :placeholder="lang.polaris.dashboard.flight_time" col="md-3"
            :help="lang.polaris.dashboard.flight_time_help"
            v-model="form.duration" :error="errors.duration" required="1">
        </trax-ui-input>

        <trax-ui-choice :placeholder="lang.polaris.dashboard.result" col="md-3" v-if="partial"
            v-model="form.success" :error="errors.success" :options="success_partial_select" 
            allow-unselect="1" required="1">
        </trax-ui-choice>

        <trax-ui-choice :placeholder="lang.polaris.dashboard.result" col="md-3" v-else
            v-model="form.success" :error="errors.success" :options="success_select" 
            allow-unselect="1" required="1">
        </trax-ui-choice>

        <trax-ui-toggle :text="lang.polaris.dashboard.atp_needed" col="md-3" 
            v-model="form.procedure">
        </trax-ui-toggle>

    </form>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-skills-test-edit'},
            source: null,
            target: null,
            partial: null,
        },

        data: function() {
            return {
                lang: lang,
                phase: data.phase,
                locations_select: data.locations_select,
                locations_names_id: data.locations_names_id,
                locations_uuid_id: data.locations_uuid_id,
                locations_id_uuid: data.locations_id_uuid,
                default_location: data.phase.custom && data.phase.custom.entity_id ? data.phase.custom.entity_id : data.phase.entity_id,
                form: {
                    entity_id: null,
                    date: '',
                    duration: '',
                    success: '',
                    procedure: 0,
                },
                success_select: [
                    {value: 3, name: lang.polaris.dashboard.pass, color: 'success'},
                    {value: 1, name: lang.polaris.dashboard.fail, color: 'danger'},
                ],
                success_partial_select: [
                    {value: 3, name: lang.polaris.dashboard.pass, color: 'success'},
                    {value: 2, name: lang.polaris.dashboard.partial_pass, color: 'warning'},
                    {value: 1, name: lang.polaris.dashboard.fail, color: 'danger'},
                ],
                errors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        methods: {

            setStates(states) {
                if (!states.summary || !states.summary.data.attempts || !states.summary.data.attempts[this.source]) {
                    this.form.entity_id = this.default_location
                    this.form.date = '';
                    this.form.duration = '';
                    this.form.success = '';
                    this.form.procedure = 0;
                    return;
                }
                var attempt = states.summary.data.attempts[this.source];
                if (attempt.location) {
                    this.form.entity_id = this.locations_id_uuid[attempt.location.entity_uuid];
                }
                this.form.date = attempt.date;
                this.form.duration = attempt.duration;
                this.form.success = attempt.success;
                this.form.procedure = attempt.procedure;
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {
                this.errors = {};
                var attempt = {};
                for (var prop in this.form) { 
                    if (prop == 'entity_id') attempt.location = {
                        entity_uuid: this.locations_uuid_id[this.form.entity_id], 
                        entity_name: this.locations_names_id[this.form.entity_id] 
                    };
                    else attempt[prop] = this.form[prop]; 
                }
                if (!data.summary.attempts) data.summary.attempts = {};
                data.summary.attempts[this.source] = attempt;
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>
